import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import BigCheckmarkCircleIcon from '../../../../../../Cutesies/BigCheckmarkCircleIcon';
import InviteParticipantStore from '../Store';
import { Link } from '../../../../../../../Resource/Types';
import { resetModal } from '.';

interface Props {
  store: InviteParticipantStore;
  link: Link;
  totalDeepLinkCount: number;
  filteredDeepLinkCount: number;
}

function Body({ store, link, totalDeepLinkCount, filteredDeepLinkCount }: Props) {
  return (
    <div className="flex justify-center items-center flex-col">
      <BigCheckmarkCircleIcon width="160" height="160" />
      <h3 className="px-4 pt-4 text-xl font-semibold">
        <T kind="Your CSV File is Ready" />
      </h3>
      <h3 className="px-4 pt-4 text-sm mb-8 mt-2">
        <T
          kind="CSV file includes {{filteredCount}} out of {{totalCount}} Program Deep Links"
          filteredCount={filteredDeepLinkCount}
          totalCount={totalDeepLinkCount}
        />
      </h3>
      <a
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-md bg-teal-600 px-3 py-2 text-white"
      >
        <T kind="Download" />
      </a>
      <div
        onClick={() => resetModal(store)}
        className="w-10 cursor-pointer text-teal-600 border-teal-600 mt-4 text-sm font-semibold"
      >
        <T kind="Back" />
      </div>
    </div>
  );
}

export default observer(Body);
